module.exports = __webpack_public_path__ + "img/chart-1.1ccdf141.png";